import { Controller } from '@hotwired/stimulus'

export class SlimSelectWithDisablerController extends Controller {
  static targets = ['checkbox', 'select']
  static values = {
    onChecked: { type: String, default: 'disable' }
  }

  connect () {
    this.onUnchecked = this.onCheckedValue === 'disable' ? 'enable' : 'disable'
  }

  toggle = (e) => {
    e.stopPropagation()

    if (this.checkboxTarget.checked) {
      this.selectTarget.slim[this.onCheckedValue]()
    } else {
      this.selectTarget.slim[this.onUnchecked]()
    }
  }
}
